import helpers from "@/helpers";
import { datiViaggio } from "@/models/carrello/datiViaggio";
import { CarrelloInfoProdotto } from "@/models/carrello/infoProdotto";
import { Preferiti } from "@/models/carrello/preferiti";
import { associaDistributoriPacchettiExtended } from "@/models/carrello/prodotti";
import api from "@/services/api";
import apiFile from "@/services/apiFile";
import { Component, Prop } from "vue-property-decorator";
import { mapMutations, mapState } from "vuex";
import baseUserContextComponent from "./baseUserContextComponent";
import { anagraficaPacchettiCategorie } from "@/models/carrello/categoria";
import popupProdottoSuggerito from "./popupCarello/popupProdottoSuggerito.vue";
import { parametriPreventivatoreItem } from "@/models/carrello/parametriPreventivatore";

const _ENDPONT = api.endpoint.CARRELLO.PREFERITI,
	_ENDPONT_INFO_PRODOTTO = api.endpoint.CARRELLO.INFO_PRODOTTO,
	_ENDPONT_DESCRIZIONE_PRODOTTO = api.endpoint.CARRELLO.DESCRIZIONE_PRODOTTO,
	_ENDPONT_PRODOTTI_SUGGERITI = api.endpoint.CARRELLO.PRODOTTI_SUGGERITI;

@Component({
	computed: {
		...mapState({
			datiViaggio: (state: any) => state.datiViaggio,
			categoria: (state: any) => state.categoria
		})
	},
	methods: {
		...mapMutations(["setProdottoPreferito", "setItemsSelected", "setProdottoSelezionato", "setDatiViaggio", "clearDatiRicercaSelezionati"])
	}
})
export default class prodottoCarrello extends baseUserContextComponent {
	@Prop({ default: () => null }) prodotto: associaDistributoriPacchettiExtended;
	@Prop({ default: () => true }) showcategoria: boolean;

	datiViaggio!: datiViaggio;

	setProdottoPreferito!: (prodottoID: number) => void;
	setItemsSelected!: (itemsSelected: number[]) => void;
	setProdottoSelezionato!: (prodotto: CarrelloInfoProdotto) => void;
	setDatiViaggio!: (datiViaggio: datiViaggio) => void;
	clearDatiRicercaSelezionati!: () => void;
	categoria!: anagraficaPacchettiCategorie;

	showModaleDettaglio: boolean = false;
	descrizioneCommerceBreve: string = "";

	beforeDestroy() {}
	beforeMount() {}
	mounted() {}
	beforeCreate() {}
	created() {}

	async aggiungiPreferito() {
		var preferito = new Preferiti();
		preferito.itemIDPacchetto = this.prodotto.itemID;

		var res = await api.chimataPost(_ENDPONT, preferito);
		if (res.status == "ok") {
			this.setProdottoPreferito(this.prodotto.itemID);
		}
	}

	async onSelezionaProdotto() {
		var self = this;
		var id = this.prodotto.pacchettoID;

		// this.clearDatiRicercaSelezionati();

		// nuova integrazione check presenza prodotto suggerito della stessa categoria se si parte da una categoria
		if(this.categoria && this.categoria.itemID){
			var par = helpers.cloneObject(this.datiViaggio.parametri) as parametriPreventivatoreItem;
			par.destinazioneGruppoStato = par.destinazioneGruppoStato ? ((par.destinazioneGruppoStato as any).value as number) || null : null;
			par.destinazioneStato = par.destinazioneStato ? ((par.destinazioneStato as any).value as number) || null : null;
			par.nazionalita = par.nazionalita ? ((par.nazionalita as any).value as number) || 1 : 1;
			par.eta = par.eta ? ((par.eta as any).value as number) || null : null;

			var resSugg = (await api.chimataPost(`${_ENDPONT_PRODOTTI_SUGGERITI}/${id}?categoriaID=${this.categoria.itemID}`, par) as any) as popupProdottoSuggerito[];
			
			if(resSugg && resSugg.length){
				// apri popup
				this.$root.$emit('openPopupProdottoSuggerito', {prodottoBase: self.prodotto, prodottoSuggerito: resSugg[0] }); 
				return;
			}
		}
		// fine nuova integrazione

		var res = await api.get(`${_ENDPONT_INFO_PRODOTTO}/${id}`);

		this.setProdottoSelezionato(res);

		var d = new datiViaggio();
		d.pacchettoID = id;
		d.parametri = this.datiViaggio.parametri;

		this.setDatiViaggio(d);

		this.$router.push({ path: "infoProdotto" as string });
	}

	async onClickDettaglio() {
		var self = this;
		var id = this.prodotto.pacchettoID;

		if (!this.descrizioneCommerceBreve) this.descrizioneCommerceBreve = await api.get(`${_ENDPONT_DESCRIZIONE_PRODOTTO}/${id}`);

		this.showModaleDettaglio = true;
	}

	async getTerminiECondizioni(prodotto) {
		var self = this;

		
		helpers.getTerminiECondizioni(this,prodotto.pacchettoID, prodotto.prodottoID);

		/*api.getWithAllDataResponse(`${api.endpoint.CARRELLO.TERMINI_E_CONDIZIONI}?pacchettoId=${prodotto.pacchettoID}&prodottoId=${prodotto.prodottoID}`, { responseType: "blob" })
		.then(res => {
			const blob = new Blob([res.data], { type: res.headers['content-type'] });

			if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                (window.navigator as any).msSaveOrOpenBlob(blob);
            } else {
                var fileURL = URL.createObjectURL(blob);
                window.open(fileURL, '_blank');
            }
		}).catch(err => {
			self.$bvToast.toast(self.$i18n.t("errore.fileNotFound").toString(), {
				variant: "danger",
				title: self.$i18n.t("generico.errore").toString(),
				solid: true
			});
		});*/
	}
}
